import React, { useState, useEffect } from "react";
import TopSellersItem from "../TopSellersItem";

// import {team2 , logoSpotify} from '../../allImgs'
// import data from './data.json'
import { getStatusMessage } from "../../utils/interact.js";
import common_land from "../../assets/common-land.gif";
import grand_land from "../../assets/grand-land.gif";
import iconic_land from "../../assets/iconic-land.gif";
import cx from "classnames";

import {
  TopSellersData1,
  TopSellersData2,
  TopSellersData3,
} from "../../data/data-components/data-TopSellers.js";

function TopSellersContainer() {
  const [statusMessage, setStatus] = useState("...");
  const [stateSuccess, setSuccess] = useState(true);
  const [stateWarning, setWarning] = useState(false);
  const [stateError, setError] = useState(false);

  setInterval(function () {
    var stateObj_ = getStatusMessage("mintSection", "status");
    if (stateObj_["value"] != stateObj_["prev"]) {
      setStatus(stateObj_["value"]);
    }
    var status_state = getStatusMessage("statusMessage", "*");
    for (var x of status_state) {
      switch (x["name"]) {
        case "success":
          setSuccess(x["value"]);
          break;
        case "warning":
          setWarning(x["value"]);
          break;
        case "error":
          setError(x["value"]);
          break;
      }
    }
  }, 50);

  return (
    <section
      id="landOptions"
      className="about-us-area section-padding-50 clearfix"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          alignItems: "center",
        }}
      >
        <a id="statusLink" href="javascript: void(0)">
          <h3
            className={cx(
              { "gradient-error": stateError },
              { "gradient-warning": stateWarning },
              { "gradient-success": stateSuccess }
            )}
          >
            {statusMessage}{" "}
          </h3>
        </a>
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-12">
            <div className="who-we-contant">
              <div className="dream-dots text-left">
                <span className="gradient-text">Land Types</span>
              </div>
              <h4 className="mb-4">Available Land Types</h4>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="creator-sec-brydge dd-bg">
              <TopSellersItem
                key={"1"}
                rank={1}
                img={common_land}
                title={"Common"}
                price={10000}
              />
            </div>
          </div>

          <div className="col-12 col-lg-4 mt-s">
            <div className="creator-sec-brydge dd-bg">
              <TopSellersItem
                key={"1"}
                rank={2}
                img={grand_land}
                title={"Grand"}
                price={68000}
              />
            </div>
          </div>

          <div className="col-12 col-lg-4 mt-s">
            <div className="creator-sec-brydge dd-bg">
              <TopSellersItem
                key={"1"}
                rank={3}
                img={iconic_land}
                title={"Iconic"}
                price={1121000}
              />
            </div>
          </div>
        </div>
        {/* <div className="col-12 col-lg-4">
          <div className="service_single_content mt-4">
            <div className="collection_info">
              <h6 className="darker-text">Land Purchase Instructions:</h6>
              <p className="mb-0 white-text">1. Approve to spend your $ATK</p>
              <p class="mb-0 white-text">
                (increase gas fee or this will fail)
              </p>
              <p className="mb-0 white-text">
                2. Wait for transation to verify
              </p>
              <p className="mb-0 white-text">
                3. Hit the 'Mint Now' on Land type
              </p>
              <p className="mb-0 white-text">4. Enter the quantity an 'Mint'</p>
              <p className="mb-0 white-text">5. Confirm the transaction</p>
            </div>
          </div>
        </div> */}
        <div className="col-12 col-lg-4">
          <div className="service_single_content mt-4">
            <div className="collection_info">
              <h6 className="darker-text">Land Purchase Instructions:</h6>
              <p className="mb-0 white-text">1. Choose how much land to Mint</p>
              <p className="mb-0 white-text">2. Select chain to purchase from</p>
              <p className="mb-0 white-text">
                3. Select token to use
              </p>
              <p className="mb-0 white-text">
                4. Approve token spend (if needed)
              </p>
              <p className="mb-0 white-text">
                5. Click 'Mint Now'
              </p>
              <p className="mb-0 white-text">6. Confirm the transaction in your wallet. Your land will arrive in your Polygon wallet shortly after!</p>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="service_single_content mt-4">
            <div className="collection_info imp-height">
              <h6 className="darker-text">Important Info:</h6>
              <p className="mb-0 white-text">
                Make sure to raise the gas fee to 'HIGH' so that your minting
                goes quickly and please BE PATIENT as some of the Polygon calls
                might take a moment. If you're having any additional trouble
                please join our{" "}
                <a href="https://discord.gg/attackwagon">Discord </a> and post
                your issues in the #🏳support channel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TopSellersContainer;
